module.exports = __webpack_public_path__ + "pc/img/img_consulting_main.5299973b.webp";